/**
 * Copyright 2022, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useContext } from 'react';
import { AuthContext } from '../components/AuthContext';
/**
 * A React hook to obtain the current value of the `AuthContext`.
 *
 * @example
 * Conditionally render a profile menu depending on whether the
 * user is authenticated or not.
 *
 * ```jsx
 * const UserProfileMenu = () => {
 *   const auth = useAuth()
 *
 *   return auth.authState === AuthState.Authenticated
 *     ? <UserProfileMenu>
 *     : <LoginButton>
 * }
 * ```
 */
export var useAuth = function () {
    return useContext(AuthContext);
};
//# sourceMappingURL=useAuth.js.map